<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getHrUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">财务账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateHrUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getHrUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <HrUserEdit ref="HrUserModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateRender } from '@/libs/tableRowTimeRender';
import HrUserEdit from './hr-user-edit';
import { getHrUserList } from '@/api/modules/account-management/hr-user-management';

export default {
    name: 'HrUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        HrUserEdit
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '姓名', key: 'userHrName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '手机号码', key: 'userHrPhone', align: 'center' },      
                    {
                        title: '审核',
                        key: 'userHrApproval',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userHrApproval))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'userHrCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.userHrCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateHrUser(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userHrName', sql: 'like' },
                    { label: '审核状态', type: 'Select', name: 'userHrApproval', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }] }

                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getHrUserTableRecords();
    },
    methods: {
        getHrUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getHrUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateHrUser() {
            this.$refs.HrUserModal.showModal();
            // this.$router.push({
            //     name: 'Hr-user-edit',
            //     query: {
            //         userHrLoginUuid: ''
            //     }
            // });
        },
        onUpdateHrUser(HrUserRow) {
            this.$refs.HrUserModal.showModal(HrUserRow.userHrLoginUuid);

            // this.$router.push({
            //     name: 'Hr-user-edit',
            //     query: {
            //         userHrLoginUuid: HrUserRow.userHrLoginUuid
            //     }
            // });
        }
    }
};
</script>

<style scoped>
</style>
